import { v4 } from "uuid";
import { getAll, setCookie } from "../cookies.js";
const DISTINCT_ID_KEY = 'session_distinct_id';
function getUserDistinctId() {
    const distinctId = getAll()[DISTINCT_ID_KEY];
    if (distinctId) return {
        distinctId,
        wasRecentlyCreated: false
    };
    const newDistinctId = v4();
    setCookie(DISTINCT_ID_KEY, newDistinctId, 365);
    window.distinctUserIdWasRecentlyCreated = true;
    return {
        distinctId: newDistinctId,
        wasRecentlyCreated: true
    };
}
const getUserDistinctId_getUserDistinctId = getUserDistinctId;
export default getUserDistinctId_getUserDistinctId;
export { DISTINCT_ID_KEY };
